export default {"src":"/_next/static/media/check-icon.61bd1e21.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};